export const environment = {
  production: false,

  // ↶↶ API Configurations ↷↷
  // Note: add base url's with trailing slash
  api: {
    baseUrl: 'http://your.api.base.url/'
  },

  // ↶↶ Authentication Configuration ↷↷
  auth: {
    authorizationUrl: 'https://pass.dev.ffuf.de/authorization/',
    tokenEndPoint: 'https://pass.dev.ffuf.de/token/',
    grantType: 'implicit_token_exchange',
    clientId: '4eddaa57-3bb9-11e7-984a-60a44c4dc960'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts